<template>
    <div class="wrapper fadeInDown">
        <div id="formContent">

            <div class="fadeIn first">
                <h4>Multi-Factor Authentication</h4>
            </div>

            <form @submit="verifyCode">
                <p class="password-helper" style="margin: 20px;">
                    A verification code has been sent to your phone. Please enter it below.
                </p>

                <input type="hidden" v-model="form.email">

                <label for="validation_code" class="left m-left-30">Verification Code</label>
                <input type="text" id="validation_code" class="login-input fadeIn second" v-model="form.validation_code"
                    placeholder="PIN (4 characters)" :class="{ 'error': validation }" required>

                <input type="submit" class="fadeIn fourth" value="Verify" :disabled="loading">
                <div v-if="loading" class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>

            </form>

            <b-button id="btn-login" block type="submit" variant="primary" :disabled="loading" class="w-50 center-m">
                <span class="spinner-border spinner-border-sm" v-show="loading" />
                Resend Code
            </b-button>

            <router-link style="margin-top: 10px;" to="/login">
                Back to Login
            </router-link>
        </div>
    </div>
</template>

<script>
// ¡IMPORTANTE! Debes crear esta nueva función 'verifyMfa' en tu archivo API
import { sendVerificationCode, activateUser } from '../../api';
import jwtDecode from 'jwt-decode';

export default {
  name: 'MfaVerify',
  data() {
    return {
      form: {
        email: '',
        validation_code: '',
      },
      jwt: '',
      menu: [],
      loading: false,
      validation: false,
    };
  },
  created() {
    this.form.email = this.$route.query.email;
    this.jwt = this.$route.query.token;
    if (!this.form.email) {
      this.$router.push('/login');
    }
  },
  methods: {
    async verifyCode(e) {
      this.loading = true;
      this.validation = false;
      e.preventDefault();

      activateUser({ data: this.form })
        .then(async () => {
          const decoded = jwtDecode(this.jwt);
          const user = decoded.identity;

          localStorage.setItem('jwt', this.jwt);
          this.$store.commit('setUser', user);

          // We wait for the permissions to load BEFORE redirecting
          try {
            // Assuming your user object has type_id directly or inside user_type
            // Adjust 'user.type_id' based on your specific JWT structure
            const roleId = user.type_id || user.user_type.type_id;

            console.log('Fetching permissions for Role ID:', roleId);

            // Dispatch the namespaced action
            await this.$store.dispatch('Users/apiGetRoleActionsByRole', roleId);
          } catch (error) {
            console.error('Failed to load permissions', error);
          }

          const menu = JSON.parse(this.$route.query.menu);
          //   const fullMenu = [...menu];
          this.$store.commit('setFullMenu', menu);

          console.log('Menu from query:', menu);

          this.$i18n.locale = user.language
            ? user.language
            : this.$i18n.locale;

          this.$store.commit(
            'setMenuPolicy',
            menu.sort((a, b) => (a.orden === b.orden ? 0 : a.orden > b.orden ? 1 : -1)),
          );

          console.log('MFA verification successful, redirecting to dashboard.');

          this.$store.commit('setLogged', true);
          this.$router.push(user.type_id !== 1 ? '/company' : 'inventory');
          this.loading = false;
        })
        .catch((e) => {
          this.validation = true;
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./login.scss";
</style>